import React, { FC } from 'react'
import { Tab } from '@headlessui/react'
import { TabContent } from '../TabContent'
import { TabPanelsProps } from './types'

const SingleTabPanel: FC<{ tabs: TabPanelsProps['tabs']; refs: TabPanelsProps['refs'] }> = ({ tabs, refs }) => (
  <Tab.Panel className="w-full">
    {tabs.map((tab) => (
      <div key={tab.title} ref={refs[tab.type]} className="scroll-mt-20">
        <TabContent tab={tab} />
      </div>
    ))}
  </Tab.Panel>
)

const MultiTabPanels: FC<{ tabs: TabPanelsProps['tabs'] }> = ({ tabs }) => (
  <>
    {tabs.map((tab) => (
      <Tab.Panel key={tab.title} className="w-full">
        <TabContent tab={tab} />
      </Tab.Panel>
    ))}
  </>
)

export const TabPanels: FC<TabPanelsProps> = ({ isSingleTab, tabs, refs }) => (
  <Tab.Panels className="w-full">
    {isSingleTab ? <SingleTabPanel tabs={tabs} refs={refs} /> : <MultiTabPanels tabs={tabs} />}
  </Tab.Panels>
)
